import { useTheme } from 'styled-components/native'

import { BREAKPOINT_ORDER, BreakpointToAssetNameMap } from '@lyrahealth-inc/shared-app-logic'

import { ThemeType } from '../utils/themes/ThemeProvider'

/**
 * Hook to get the correct asset for the current breakpoint
 * @param breakpointToAssetNameMap Map of breakpoint to asset name (see assets.ts for examples)
 * @returns The asset name for the current breakpoint
 */
export const useGetResponsiveAssets = (breakpointToAssetNameMap: BreakpointToAssetNameMap): string => {
  const { breakpoints } = useTheme() as ThemeType

  const matchingBreakpoint = BREAKPOINT_ORDER.find(
    (breakpoint) =>
      breakpoints[breakpoint] === true && breakpointToAssetNameMap[breakpoint as keyof BreakpointToAssetNameMap],
  )

  return (
    breakpointToAssetNameMap[matchingBreakpoint as keyof BreakpointToAssetNameMap] ||
    breakpointToAssetNameMap.defaultAsset
  )
}
